import React from 'react'
import BookInfosRow from './BookInfosRow';

import '../assets/styles.css';

export default function PreviewData() {
    
    return (
        //<!-- Preview Data -->
        <div className="table-container">
            <table className="booking-table">
                <thead className="bg-gray-100/50">
                    <tr className="text-black text-left">
                        <th>Destination From</th>
                        <th>Destination To</th>
                        <th className="text-center">Journey Date</th>
                        <th className="text-center">Guests</th>
                        <th className="text-center">className</th>
                        <th className="text-center">Delete</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-300/20" id="lws-previewBooked">
                    <BookInfosRow />
                </tbody>
            </table>
        </div>
    )
}
